import React, { useEffect } from 'react'
import DateInputWrapper from './date-input-wrapper'
import SelectInputWrapper from './select-input-wrapper'

export default function Recurring({register, unregister, errors, setValue, intervals, baseDate, endDate, onDateChange}) {
  useEffect(() => {
    return () => {
      unregister('interval')
    }
  }, [])

  const onChangeEndDate = (date) => {
    const formattedDate = (date || moment()).format('MM/DD/YYYY')
    onDateChange(formattedDate)
  }

  return <div className='row'>
    <br/>
    <div className='col-sm-4'>
      <SelectInputWrapper
        {...register('interval')}
        label='Interval:' 
        options={intervals} 
        onChange={(e) => setValue('interval', e.target.value)}
      />
    </div>
    <div className='col-sm-4'>
      <DateInputWrapper
        label='Start from:'
        disabled={true}
        date={moment(new Date(baseDate))}
      />
    </div>
    <div className='col-sm-4'>
      <DateInputWrapper
        label='Stop at:'
        onChange={(date) => onChangeEndDate(date)}
        date={moment(new Date(endDate || baseDate))}
        error={errors.end_date}
      />
    </div>
  </div>
}
